define('home/views/SearchPageLayout',[
    'backbone-marionette',
    'home/models/SearchManager',
    'home/views/SearchResultsView',

    'home/templates/searchPage',
], function (
    Marionette,
    SearchManager,
    SearchResultsView,

    searchPageTemplate
) {
    'use strict';

    return Marionette.Layout.extend({
        template: searchPageTemplate,

        ui: {
            query: '[data-role=search-query]',
        },

        events: {
            'submit': 'handleSearchRequest',
        },

        regions: {
            resultsRegion: '[data-role=search-results]',
        },

        initialize: function (options) {
            this.session = options.session;
        },

        getMetaAttrs: function () {
            return 'Search';
        },

        handleSearchRequest: function (ev) {
            ev.preventDefault();

            var searchManager = new SearchManager({
                query: this.ui.query.val(),
                userId: this.session.user.get('id'),
            });

            searchManager.fetchSearchResults();

            this.resultsRegion.show(new SearchResultsView({
                model: searchManager,
            }));
        },
    });
});

